module.exports = __webpack_public_path__ + "img/u895.22bb518e.svg";